import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

export default function Download() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F8F7] text-[#101F1F] font-lexend">
      <Navbar />
      <main className="flex-grow pt-32 pb-24 px-6 lg:px-8 max-w-3xl mx-auto w-full text-center">
        <h1 className="text-4xl lg:text-6xl font-bold tracking-tight mb-6 text-[#244A49]">
          Create Your RepUpgrade Access
        </h1>
        <p className="text-xl text-gray-600 mb-6 leading-relaxed">
          Start by creating access so RepUpgrade can prepare your first Reputation Report & Action Plan.
        </p>

        <div className="bg-white p-12 rounded-[2rem] shadow-sm border border-gray-100 flex flex-col gap-4 items-center max-w-md mx-auto">
          <Link 
            to="/create-access"
            className="w-full bg-[#F49558] hover:bg-[#D35E0E] text-white text-lg font-bold py-4 px-10 rounded-xl shadow-lg transition-all text-center"
          >
            Get Upgraded
          </Link>
          <Link 
            to="/how-it-works" 
            className="w-full bg-white hover:bg-gray-50 text-[#101F1F] border border-gray-200 shadow-sm text-lg font-bold py-4 px-10 rounded-xl transition-all text-center"
          >
            See How It Works
          </Link>
          <Link 
            to="/playground" 
            className="w-full bg-transparent text-[#409FA1] hover:text-[#244A49] text-lg font-bold py-4 px-10 rounded-xl transition-all text-center mt-2"
          >
            Explore the Report
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}